import { CurrentAuthority } from './typings.d'
import { whatType } from '-/utils/index'

/* eslint-disable import/no-mutable-exports */
let CURRENT_AUTHORITY: string | string[] = 'NULL'
/**
 * use  authority or getAuthority
 * @param {string|()=>String} currentAuthority
 */
const renderAuthorize = <T>(Authorized: T): ((currentAuthority: CurrentAuthority) => T) => (
  currentAuthority: CurrentAuthority
) => {
  if (currentAuthority) {
    if (typeof currentAuthority === 'function') {
      CURRENT_AUTHORITY = currentAuthority()
    }

    if (whatType(currentAuthority) === 'string' || Array.isArray(currentAuthority)) {
      CURRENT_AUTHORITY = currentAuthority as string | string[]
    }
  } else {
    CURRENT_AUTHORITY = 'NULL'
  }

  return Authorized
}

export { CURRENT_AUTHORITY }
export default function<T>(Authorized: T): (currentAuthority: CurrentAuthority) => T {
  return renderAuthorize(Authorized)
}
